import { NodeModel } from "@minoru/react-dnd-treeview";
import { Badge, Box } from "@mui/material";
import React from "react";
import { FileProperties } from "../../models/FileProperties";
import { TypeIcon } from "../node/TypeIcon";

type Props = {
	dragSources: NodeModel<FileProperties>[];
};

export const MultipleDragPreview: React.FC<Props> = (props) => {
	return (
		<Badge
			sx={{
				badge: { border: "solid 2px #fff" },
			}}
			color="error"
			badgeContent={props.dragSources.length}
			anchorOrigin={{ vertical: "top", horizontal: "right" }}
		>
			<Box
				sx={{
					alignItems: "flex-start",
					backgroundColor: "#1967d2",
					borderRadius: "4px",
					boxShadow:
						"0 12px 24px -6px rgba(0, 0, 0, 0.25); 0 0 0 1px rgba(0, 0, 0, 0.08)",
					display: "flex",
					flexDirection: "column",
					gap: "4px",
					padding: "8px",
				}}
				data-testid="custom-drag-preview"
			>
				{props.dragSources.map((node) => (
					<Box
						sx={{
							alignItems: "center",
							color: "#fff",
							display: "inline-grid",
							fontSize: "0.875rem",
							gap: "8px",
							gridTemplateColumns: "auto auto",
						}}
					>
						<Box sx={{ alignItems: "center", display: "flex" }}>
							<TypeIcon
								droppable={node.droppable || false}
								fileType={node?.data?.fileType}
							/>
						</Box>
						<Box sx={{ alignItems: "center", display: "flex" }}>
							{node.text}
						</Box>
					</Box>
				))}
			</Box>
		</Badge>
	);
};
